// Single source of truth for the "you replace N tools with 1" comparison shown
// on the pricing page (Replace-5-tools widget).
//
// These are the public monthly list prices, in USD (their native billing
// currency), of the mainstream paid AI/productivity tools that a single Stronger
// Bot subscription replaces. Factual public offers as of REPLACED_TOOLS_DATE, no
// logos — same legal framing as the head-to-head table (ComparePage COMPETITORS,
// a separate concern).
//
// Update ONLY here when a price changes or a tool is added/removed: the pricing
// widget derives the stacked total AND the savings vs Stronger Bot Pro from this
// list + data/plans.js PLAN_PRICES, so no sum is ever hardcoded again (the old
// widget shipped "143 $" / "124 $" as literals that would silently drift).
export const REPLACED_TOOLS = [
  { name: "ChatGPT Plus", priceUsd: 20 },
  { name: "Notion AI", priceUsd: 10 },
  { name: "Canva Pro", priceUsd: 15 },
  { name: "Copy.ai", priceUsd: 49 },
  { name: "Jasper", priceUsd: 49 },
];

// Public prices captured as of this month (shown/date-stamped like ComparePage).
export const REPLACED_TOOLS_DATE = "2026-09";
